import React from 'react';
import Type from 'prop-types';
import { useToggle } from 'react-use';
import { Field, useFormikContext } from 'formik';
import { createFilterOptions, Typography } from '@mui/material';
import { useTranslation } from 'hooks';
import AutocompleteField from '../AutocompleteField';
import NewEmailDialog from './NewEmailDialog';

const filter = createFilterOptions({
  stringify: ({ name, email }) => `${email} ${name.last} ${name.first}`,
});

const EmailField = (props) => {
  const { name, loading, ...other } = props;
  const [isDialogOpened, toggleDialog] = useToggle(false);
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext();

  const handleEmailChange = (event, newValue) => {
    if (newValue && newValue.inputValue) {
      toggleDialog();
    } else {
      setFieldValue(name, newValue);
    }
  };

  const handleEmailSave = ({ email }) => {
    setFieldValue(name, { email });

    toggleDialog();
  };

  const renderOption = (liProps, option) => {
    const { name: nameProp, email, contactId } = option;
    const fullName = nameProp ? `${nameProp.last} ${nameProp.first}` : '';
    return (
      <li {...liProps} key={contactId}>
        <Typography variant="body1">{fullName}</Typography>
        <Typography variant="body2" color="textSecondary">
          {email}
        </Typography>
      </li>
    );
  };

  const filterOptions = (options, params) => {
    const filtered = filter(options, params);

    if (params.inputValue !== '') {
      filtered.push({
        inputValue: params.inputValue,
        email: t('addNewEmail'),
      });
    }

    return filtered;
  };

  return (
    <>
      <Field
        id={name}
        name={name}
        component={AutocompleteField}
        getOptionLabel={(option) => option[name]}
        onChange={handleEmailChange}
        renderOption={renderOption}
        filterOptions={filterOptions}
        clearOnBlur
        freeSolo
        {...other}
      />

      <NewEmailDialog
        open={isDialogOpened}
        onConfirm={handleEmailSave}
        onCancel={toggleDialog}
      />
    </>
  );
};

EmailField.propTypes = {
  name: Type.string.isRequired,
  loading: Type.bool.isRequired,
  TextFieldProps: Type.shape({
    label: Type.string.isRequired,
    required: Type.bool,
    margin: Type.oneOf(['none', 'dense', 'normal']),
  }),
};

EmailField.defaultProps = {
  TextFieldProps: {},
};

export default EmailField;
